import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import LandingPage from './pages/landing/LandingPage';
import Dashboard from './pages/Dashboard';
import AdminLayout from './pages/admin/AdminLayout';
import LeaveManagement from './pages/admin/LeaveManagement';
import SubWorkAssignment from './pages/admin/SubWorkAssignment';
// ExternalUserManagement, ExternalLeaveManagement 제거: /admin/ext/:code/* 라우트로 대체됨
import SituationBoard from './pages/admin/SituationBoard';
import SituationWidgetManagement from './pages/admin/SituationWidgetManagement';
import TicketTypeManagement from './pages/admin/TicketTypeManagement';
import MyProductManagement from './pages/admin/productmgmt/MyProductManagement';
import AdminMeetingMap from './pages/admin/AdminMeetingMap';
import RegionCoverage from './pages/admin/RegionCoverage';
import ContractManagement from './pages/admin/ContractManagement';
import ContractCancelManagement from './pages/admin/ContractCancelManagement';
import QuoteManagement from './pages/admin/QuoteManagement';
import RevenueManagement from './pages/admin/RevenueManagement';
import PromotionalManagement from './pages/admin/PromotionalManagement';
import PromotionalCostManagement from './pages/admin/PromotionalCostManagement';
import PromotionalMonthlySettlement from './pages/admin/PromotionalMonthlySettlement';
import DbManagement from './pages/admin/DbManagement';
import LogManagement from './pages/admin/LogManagement';
import EmployeeView from './pages/admin/EmployeeView';
import AdminSettlementManagement from './pages/admin/AdminSettlementManagement';
import IntegratedMenuPage from './pages/admin/IntegratedMenuPage';
// 직원 본인 화면 wrapper (Step 4-5) — admin도 진입 가능 (위장 접속 + admin이 직원 화면 보기)
import MyAttendancePage from './pages/my/MyAttendancePage';
import MyLeavesPage from './pages/my/MyLeavesPage';
import MyPayslipsPage from './pages/my/MyPayslipsPage';
// 2026-04-29: TmCallsExtPage 폐기 — DOT/LNJ 분리 (CallRegister 직접 사용)
// 직원 본인용 화면 — 동일 컴포넌트 재사용 (adminMode={false} 등). CallRegister/RegionCoverage는 기존 import 재활용.
import Settlement        from './pages/employee/Settlement';
import SettlementDot     from './pages/employee/SettlementDot';
import SettlementLnj     from './pages/employee/SettlementLnj';
import TmContractsMy     from './pages/tm/TmContracts';
import TmRecentContractsMy from './pages/tm/TmRecentContracts';
import TmSummary         from './pages/tm/TmSummary';
import MeetingMapMy      from './pages/tm/MeetingMap';
import PayoutManagement from './pages/admin/PayoutManagement';
import PayrollManagement from './pages/admin/PayrollManagement';
import AnnualLeaveSettlement from './pages/admin/leavesettlement/AnnualLeaveSettlement';
import ConfidentialLockGate from './pages/admin/confidential/ConfidentialLockGate';
import ScoreManagement       from './pages/admin/scoremgmt/ScoreManagement';
import AdminMarketerConsultantPage from './pages/admin/AdminMarketerConsultantPage';
import IncentiveManagement from './pages/admin/incentive/IncentiveManagement';
import EmergencyTeamManagement from './pages/admin/EmergencyTeamManagement';
import ContractRenewalManagement from './pages/admin/contractrenewal/ContractRenewalManagement';
import ReservationManagement from './pages/admin/ReservationManagement';
import ReservationDetail     from './pages/admin/ReservationDetail';
import ReservationForm       from './pages/admin/ReservationForm';
import ReservationRevenue    from './pages/admin/ReservationRevenue';
import CashflowDashboard     from './pages/admin/CashflowDashboard';
import CashflowPurchaseManagement from './pages/admin/CashflowPurchaseManagement';
import CallRegister from './pages/tm/CallRegister';
import PrivateRoute from './components/PrivateRoute';
// 인라인이던 라우트 컴포넌트 17개를 두 파일로 분리했다 (2026-09-10, 300줄 규칙). 동작 변경 없음.
import {
  HomeRedirect, AdminBoardGuard, AdminHomeRoute, MyIndexRedirect, ImpTokenInitializer,
  WorkAssignmentRoute, SaasTenantsRoute, UsersRoute, IntegratedMenusRoute, IntegratedHomeRoute,
} from './AppRoutes.guards';
import {
  HqAttendanceHub, HqAttendanceCalendarRedirect, ExtAttendanceCalendarRedirect,
} from './pages/admin/attendancehub/AttendanceHubRoutes';
import {
  MyExtCallRoute, COMPANY_ELEMENTS, CompanyRouteGuard, HqRoute, CallAllRoute,
} from './AppRoutes.company';
// 회사 공통 기능 16종의 주소는 이 표 한 장에서 나온다 (2026-09-11 C2).
// 사이드바·홈 런처도 같은 표를 읽으므로 "메뉴에는 뜨는데 주소가 없다" 가 생길 자리가 없다.
import { COMPANY_MENU_FEATURES, companyFeatureRoutePath } from './pages/admin/adminlayout/companyFeatures';


export default function AppRoutes() {
  return (
    <>
    <ImpTokenInitializer />
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* 소개 페이지 미리보기 — 스위치(app_settings landing_page_enabled)와 상관없이 항상 열린다(2026-09-28).
          실제 첫 주소(/)에 뜨는지는 HomeRedirect 가 스위치·로그인 기록으로 정한다. */}
      <Route path="/intro" element={<LandingPage />} />
      <Route
        path="/dashboard/*"
        element={(
          <PrivateRoute role="employee">
            <Dashboard />
          </PrivateRoute>
        )}
      />
      {/* 직원 본인 화면 (Step 4) — AdminLayout 재사용. employee/admin 모두 진입 가능. */}
      <Route
        path="/my"
        element={(
          <PrivateRoute role="employee">
            <AdminLayout userRole="employee" />
          </PrivateRoute>
        )}
      >
        <Route index element={<MyIndexRedirect />} />
        <Route path="board"      element={<SituationBoard />} />
        <Route path="attendance" element={<MyAttendancePage />} />
        <Route path="leaves"     element={<MyLeavesPage />} />
        <Route path="payslips"   element={<MyPayslipsPage />} />
        {/* Step 5 — TM/정산서/계약 등 11개 직원 본인 화면 (같은 컴포넌트 재사용) */}
        <Route path="tm-calls"        element={<CallRegister adminMode={false} key="my-tm" />} />
        <Route path="tm-calls-jeju"   element={<CallRegister adminMode={false} scope="jeju" key="my-tm-jeju" />} />
        <Route path="tm-calls-dot"    element={<CallRegister adminMode={false} companyCode="DOT" key="my-tm-dot" />} />
        <Route path="tm-calls-lnj"    element={<CallRegister adminMode={false} companyCode="LNJ" key="my-tm-lnj" />} />
        {/* 회사별 동적 콜 라우트 — DOT/LNJ 외 신규 회사(테넌트)용. 메뉴는 buildExtCallMenus 가 생성.
            서버가 call_company_code 를 배정(TM_FEATURE_EXT_{CODE}) 보유 여부로 검증하므로 경로 위조는 403. */}
        <Route path="tm-calls-ext/:code" element={<MyExtCallRoute />} />
        <Route path="settlement"      element={<Settlement />} />
        <Route path="settlement-dot"  element={<SettlementDot />} />
        <Route path="settlement-lnj"  element={<SettlementLnj />} />
        <Route path="contracts"       element={<TmContractsMy />} />
        <Route path="recent-contracts" element={<TmRecentContractsMy />} />
        <Route path="summary"         element={<TmSummary />} />
        <Route path="meeting-map"     element={<MeetingMapMy />} />
        <Route path="region-coverage" element={<RegionCoverage />} />
        <Route path="work-feature-assignments" element={<SubWorkAssignment />} />
        <Route path="work-assignments" element={<Navigate to="/my/work-feature-assignments" replace />} />
      </Route>
      {/* 옵션 3 (2026-04-27): role='admin' 차단 제거 → employee 도 권한 보유 시 진입 가능.
          사이드바는 menuConfig.permCode 기반 자동 필터, 페이지 자체 권한 미보유 시 빈 데이터 노출 (백엔드 401/403 보호).
          admin 자동 모든 권한 보유 — 변경 zero. */}
      <Route
        path="/admin"
        element={(
          <PrivateRoute role="employee">
            <AdminLayout />
          </PrivateRoute>
        )}
      >
        {/* 2026-08-26 A안: /admin 진입 기본 = 홈(기능 카드 런처). 상황판은 위젯 전용 모니터링 */}
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<AdminHomeRoute />} />
        <Route path="board" element={<AdminBoardGuard />} />
        <Route path="situation-widgets" element={<SituationWidgetManagement />} />
        <Route path="users" element={<UsersRoute />} />
        {/* 옛 IP 관리 주소 → 출퇴근 관리(☰ 'IP 관리' 창, 2026-10-23) */}
        <Route path="ips" element={<Navigate to="/admin/attendance" replace />} />
        <Route path="leaves" element={<LeaveManagement />} />
        {/* 본사 화면은 회사값을 HqRoute 로 받는다 (2026-09-11 C3 2단계) — 'PINE' 고정이면
            미팅링크에서 자기 데이터(LINK)를 못 찾는다. 파인그룹은 답이 'PINE' 이라 전과 같다. */}
        {/* 파인 화면도 회사값을 **명시**해서 넘긴다 (2026-09-10, 구조 개편 2단계 C1).
            컴포넌트의 companyCode 기본값이 'PINE' 이라 안 넘겨도 지금은 같게 동작하지만,
            그 기본값은 "회사값이 안 오면 조용히 파인 데이터를 보여준다" 는 뜻이기도 하다.
            명시 전달을 먼저 깔아두고, 기본값 제거는 파인이 다른 회사와 같은 주소를 쓰게 된 뒤에 한다. */}
        {/* 본사(파인그룹) 급여 관리: companyCode='PINE' */}
        <Route
          path="payroll"
          element={<HqRoute>{(code) => <PayrollManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route
          path="leave-settlement"
          // 대외비(2026-10-16) — 비밀번호가 풀린 뒤에 화면이 열려야 자료를 처음부터 불러온다
          element={<HqRoute>{(code) => <ConfidentialLockGate key={code} companyCode={code} menuName="연차정산" menuKey="leave_settlement"><AnnualLeaveSettlement companyCode={code} /></ConfidentialLockGate>}</HqRoute>}
        />
        <Route path="scores" element={<ScoreManagement companyCode="PINE" />} />
        {/* 본사 인센티브 관리 — 전에는 'PINE' 고정이라 미팅링크에서 자기 규칙 1건을 못 찾았다 (2026-09-11). */}
        <Route
          path="incentives"
          element={<HqRoute>{(code) => <IncentiveManagement key={code} companyCode={code} />}</HqRoute>}
        />
        {/* 비상대응팀 — 화면이 'PINE' 을 직접 보내고 있어 미팅링크에서 자기 배정이 안 보였다 (2026-09-11). */}
        <Route
          path="emergency-team"
          element={<HqRoute>{(code) => <EmergencyTeamManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route
          path="contract-renewals"
          element={<HqRoute>{(code) => <ContractRenewalManagement key={code} companyCode={code} />}</HqRoute>}
        />
        {/* 출퇴근 관리 = [달력][직원별 상세] 탭 (2026-09-29 출퇴근 달력 합치기). 예전 달력 주소는 달력 탭으로 넘긴다. */}
        <Route path="attendance" element={<HqAttendanceHub />} />
        <Route path="attendance-calendar" element={<HqAttendanceCalendarRedirect />} />
        {/* 옛 '(통합)' A — 회사 2곳+ 테넌트는 문지기가 B·통합 일일콜 메뉴로 보낸다 (2026-10-14) */}
        <Route path="tm-calls"       element={<CallAllRoute><CallRegister adminMode key="tm-all" /></CallAllRoute>} />
        {/* tm-calls-movie 제거: 외부 회사별 동적 라우트(/admin/ext/:code/tm-calls)로 대체 */}
        <Route path="tm-calls-jeju"  element={<CallRegister adminMode scope="jeju"  key="tm-jeju" />} />
        <Route path="meeting-map" element={<AdminMeetingMap />} />
        <Route path="region-coverage" element={<RegionCoverage adminMode />} />
        <Route path="ticket-types" element={<TicketTypeManagement />} />
        <Route path="products" element={<MyProductManagement />} />
        <Route path="work-feature-assignments" element={<WorkAssignmentRoute />} />
        {/* 회사 공통 기능 16종 — /admin/ext/:code/{주소조각}. 표(companyFeatures.js)가 주소를,
            COMPANY_ELEMENTS 가 화면을 갖는다. 표에 한 줄 넣으면 메뉴와 주소가 함께 생긴다. */}
        {COMPANY_MENU_FEATURES.filter((f) => COMPANY_ELEMENTS[f.key]).map((f) => (
          <Route
            key={f.key}
            path={companyFeatureRoutePath(f)}
            element={<CompanyRouteGuard feature={f}>{COMPANY_ELEMENTS[f.key]}</CompanyRouteGuard>}
          />
        ))}
        {/* 회사별 예전 달력 주소 → 그 회사 출퇴근 관리의 달력 탭 (표에서는 빠졌고 주소만 살려 둔다) */}
        <Route path="ext/:code/attendance-calendar" element={<ExtAttendanceCalendarRedirect />} />
        <Route path="contracts" element={<ContractManagement />} />
        <Route
          path="contract-cancellations"
          element={<HqRoute>{(code) => <ContractCancelManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route path="quotes" element={<QuoteManagement />} />
        {/* 예약 관리 (Phase 2 조회 + Phase 3-B 신규 등록) */}
        <Route path="reservations" element={<ReservationManagement />} />
        <Route path="reservations/new" element={<ReservationForm />} />
        <Route path="reservations/:code" element={<ReservationDetail />} />
        <Route path="reservation-revenue" element={<ReservationRevenue />} />
        <Route path="revenue" element={<RevenueManagement />} />
        <Route path="promotional" element={<PromotionalManagement />} />
        <Route path="promotional-cost" element={<PromotionalCostManagement />} />
        <Route path="promotional-monthly-settlement" element={<PromotionalMonthlySettlement />} />
        {/* 흐름은 회사 구분이 없는 본사 메뉴 — 본사 회사의 대외비 비밀번호로 잠근다(2026-10-16) */}
        <Route path="cashflow" element={<HqRoute>{(code) => <ConfidentialLockGate key={code} companyCode={code} menuName="흐름" menuKey="cashflow"><CashflowDashboard /></ConfidentialLockGate>}</HqRoute>} />
        {/* 본사 매입 — 'PINE' 고정이라 미팅링크 매입(LINK)이 안 보였다 (2026-09-14 C3).
            샘이콜론은 본사가 아니라 별개 사업자라 그대로 둔다. */}
        <Route
          path="cashflow/purchases"
          element={<HqRoute>{(code) => <CashflowPurchaseManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route path="cashflow/purchases/semecolon" element={<CashflowPurchaseManagement companyCode="SEMECOLON" />} />
        <Route path="saas-tenants" element={<SaasTenantsRoute />} />
        <Route path="db" element={<DbManagement />} />
        <Route path="logs" element={<LogManagement />} />
        <Route path="employee-view" element={<EmployeeView />} />
        <Route
          path="settlement-management"
          element={<HqRoute>{(code) => <AdminSettlementManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route
          path="payout-management"
          element={<HqRoute>{(code) => <PayoutManagement key={code} companyCode={code} />}</HqRoute>}
        />
        <Route path="payout-management-LNJ" element={<PayoutManagement companyCode="LNJ" />} />
        <Route path="payout-management-DOT" element={<PayoutManagement companyCode="DOT" />} />
        {/* 본사 마케터 1:1 — 회사값은 장부가 답한 주인 회사 (2026-09-11 C3 2단계).
            전에는 'PINE' 고정이라 미팅링크에서 자기 배정 3건을 못 찾고 빈 화면이었다. */}
        <Route
          path="marketer-consultant"
          element={(
            <HqRoute>
              {(code) => (
                <AdminMarketerConsultantPage
                  key={code}
                  fixedCompanyCode={code}
                  fixedCompanyName={code}
                  pageTitle="마케터 1:1 관리"
                />
              )}
            </HqRoute>
          )}
        />
        {/* 통합 메뉴 관리 (Phase 1-1b): 운영사 전용 — IntegratedMenusRoute 가 화면 쪽에서도 막는다(2026-10-01) */}
        <Route path="integrated-menus" element={<IntegratedMenusRoute />} />
        {/* 통합 관리 홈 (2026-10-01): 작업 대상 회사 칸의 "통합관리" — 통합 메뉴를 모아 보고 관리 */}
        <Route path="integrated" element={<IntegratedHomeRoute />} />
        {/* 통합 메뉴 진입점 (Phase 1-1d): feature_type별 화면 디스패처 */}
        <Route path="integrated/:menuId" element={<IntegratedMenuPage />} />
        {/* payroll-management-dot 제거: /admin/ext/:code/payroll 동적 라우트로 대체 */}
        <Route path="work-assignments" element={<Navigate to="/admin/work-feature-assignments" replace />} />
      </Route>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="*" element={<HomeRedirect />} />
    </Routes>
    </>
  );
}
